export type ProjectListingsDisplayMode = 'table' | 'byStage';

export const resolveProjectListingsDisplayMode = ({
  displayMode,
  isDisabledMode,
}: {
  displayMode: ProjectListingsDisplayMode;
  isDisabledMode?: boolean;
}): ProjectListingsDisplayMode => (isDisabledMode ? 'table' : displayMode);
